import React, { useCallback, useContext, useEffect, useState } from "react";
import copy from "../../images/copy.svg";
import copy2 from "../../images/copy2.svg";
import like from "../../images/like.svg";
import Functions from "./functions";
import {
  useGetBookingCodes,
  useGetCurrentUser,
  useSupportedBookies,
  useUserPublicCodes,
} from "../../api/queries";
import { Button, useToast } from "../../lib";
import moment from "moment";
import sort from "../../images/sort.svg";
import {
  useCopyBookinCode,
  useLikeBookingCode,
  useLogin,
  useUnLikeBookingCode,
} from "../../api/mutations";
import { useRecoilState } from "recoil";
import { auth_user } from "../../atom";
import { NavLink, useNavigate } from "react-router-dom";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { LoginSchema } from "../../validation/schema";
import { saveToken } from "../../lib/utils";
import AuthContext from "../../context/AuthContext";
import { IoCloseCircleOutline } from "react-icons/io5";
import Pagination from "./pagination";
import Countdown from "react-countdown";

const Table = () => {
  const { setAuth } = useContext(AuthContext);
  const [filter, setFilter] = useState({ bookies: "" });
  const toast = useToast();
  const { mutateAsync, isPending } = useLogin();
  const [user, setAuthUser] = useRecoilState(auth_user);
  const isSignedIn = Boolean(Object.keys(user || {}).length);
  const { data, refetch } = useUserPublicCodes(filter, !isSignedIn);
  const [text, setText] = useState("");
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const { mutateAsync: likeBookinCode } = useLikeBookingCode();
  const { mutateAsync: unlikeBookinCode } = useUnLikeBookingCode();
  const { mutateAsync: copyBookingCode } = useCopyBookinCode();
  const { refetch: reload, isLoading } = useGetCurrentUser();
  const [betCodes, setBetCodes] = useState([]);
  const { data: bookies } = useSupportedBookies("ng");
  const [isOpen, setIsOpen] = useState(false);
  const { data: bookingCodes, refetch: reload_data } = useGetBookingCodes(
    filter,
    isSignedIn
  );
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  const handleCopyCode = useCallback(async (code, bookingCodeExternalId) => {
    try {
      await copyBookingCode({
        bookingCodeExternalId,
      });
      reload_data();
      navigator.clipboard.writeText(code).then(() => {
        toast({
          type: "success",
          message: "Code Copied",
        });
      });
    } catch (e) {
      console.log(e, "error");
    }
  }, []);

  const handleLike = useCallback(async (bookingCodeExternalId) => {
    try {
      await likeBookinCode({
        bookingCodeExternalId,
      });
      reload_data();
    } catch (e) {
      if (
        e?.response?.data?.message ===
        "User has already liked this booking code"
      ) {
        await unlikeBookinCode({
          bookingCodeExternalId,
        });
        reload_data();
      }
    }
  }, []);

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <p>Expired</p>;
    } else {
      return (
        <>
          <div className="flex text-[#7e00cc] justify-start items-center gap-1">
            {[
              {
                value: days,
                title: "Days",
              },
              { value: hours, title: "Hours" },
              {
                value: minutes,
                title: "Minutes",
              },
              { value: seconds, title: "Seconds" },
            ].map((entry, idx) => (
              <p key={entry.title} className="font-tomato-regular text-sm ">
                {entry.value}
                {entry.title !== "Seconds" ? " :" : ""}
              </p>
            ))}
          </div>
        </>
      );
    }
  };

  const handleSubmit = async (values) => {
    try {
      const response = await mutateAsync(values);
      const accessToken = response?.accessToken;
      const refreshToken = response?.refreshToken;
      saveToken("accessToken", accessToken);
      saveToken("refreshToken", refreshToken);

      const { data } = await reload();
      setAuthUser(data);
      setAuth({ accessToken, refreshToken });
      await reload_data();
      toast({
        type: "success",
        message: "Authenticated",
      });
      setOpenModal(false);
    } catch (error) {
      console.log(error, "error");
      toast({
        type: "error",
        message: error?.response?.data?.message ?? "An Error occured",
      });
    }
  };
  const toggleMenu = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  useEffect(() => {
    if (Object.keys(user || {}).length) {
      setBetCodes(bookingCodes?.data || []);
    } else if (Object.keys(user || {}).length === 0) {
      setBetCodes(data?.data || []);
    }
  }, [user, bookingCodes, data]);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const visibleBetCodes = Array.isArray(betCodes)
    ? betCodes.slice(startIndex, endIndex)
    : [];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="bac-table">
      {openModal && (
        <div
          className="w-full z-50 h-screen fixed flex justify-center items-center top-0"
          onClick={() => setOpenModal(false)}
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="md:h-[500px] rounded-sm w-[95%] h-[70%]  lg:p-20 p-6 lg:w-[50%] bg-white"
          >
            <h3 className="header-signup lg:text-[30px] text-[20px] md:text-[40px]">
              Oh! You need to login to use
              <br /> Cuppycode for FREE
            </h3>
            <div className="flex justify-between items-center gap-3">
              <Formik
                initialValues={{ username: "", password: "" }}
                validationSchema={LoginSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting }) => (
                  <Form className="row padding-form ">
                    <div className="col-md-6 col-12">
                      <Field
                        className="input-z"
                        type="text"
                        name="username"
                        placeholder="Enter Username e.g Swiftkid"
                      />
                      <ErrorMessage
                        className="form-field-error"
                        name="username"
                        component="div"
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <Field
                        className="input-z"
                        type="password"
                        name="password"
                        placeholder="Enter Password"
                      />
                      <ErrorMessage
                        className="form-field-error"
                        name="password"
                        component="div"
                      />
                    </div>
                    <div className="flex lg:flex-row flex-col lg:justify-between lg:items-center mt-10">
                      <p className="forgot">
                        Don't have an account?{" "}
                        <span className="terms">
                          {" "}
                          <NavLink to="/signup" className="login">
                            {" "}
                            Register{" "}
                          </NavLink>
                        </span>
                      </p>

                      <div className="flex justify-center lg:justify-end">
                        <Button loading={isPending || isLoading}>Login</Button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}

      {isOpen && (
        <div
          style={{ fontFamily: "Outfit" }}
          className="fixed top-0 w-full left-0 h-screen bg-[rgba(0,0,0,0.5)] z-50"
        >
          <div className="flex justify-between w-full text-black h-full">
            <div className="h-full w-full lg:w-1/4 bg-white transition-all ease-in-out relative p-4 pb-10 overflow-x-scroll">
              <div
                onClick={() => toggleMenu()}
                className="absolute right-0 top-0 m-4 cursor-pointer"
              >
                <IoCloseCircleOutline size={25} />
              </div>
              <h2 className="font-semibold text-lg pt-16">
                Filter bookings code by
              </h2>
              <div className="pt-4 ">
                <h4 className="font-regular text-sm text-[rgba(0,0,0,0.5)]">
                  Odd
                </h4>
                <input
                  className="input-z"
                  type="number"
                  name="username"
                  onChange={(event) =>
                    setFilter((prev) => ({
                      ...prev,
                      minOdds: event.target.value,
                    }))
                  }
                  placeholder="Enter Minimum Odds value"
                />
                <input
                  className="input-z"
                  type="number"
                  name="username"
                  onChange={(event) =>
                    setFilter((prev) => ({
                      ...prev,
                      maxOdds: event.target.value,
                    }))
                  }
                  placeholder="Enter Maximum Odds value"
                />
                <h4 className="font-regular pt-4 text-sm text-[rgba(0,0,0,0.5)]">
                  Booking platform
                </h4>
                <div className="w-full pt-2 flex flex-wrap justify-start items-center gap-2">
                  {Array.isArray(bookies)
                    ? bookies.map((element) => (
                      <div
                        className="flex justify-start items-start gap-0 font-regular text-sm text-black"
                        key={element?.brand}
                      >
                        <input
                          value={element.bookie}
                          type="checkbox"
                          id={element.brand}
                          onChange={() => {
                            const current = filter?.bookies || "";
                            const selectedSet = new Set(
                              current ? current.split(",") : []
                            );
                            if (selectedSet.has(element.bookie)) {
                              selectedSet.delete(element.bookie);
                            } else {
                              selectedSet.add(element.bookie);
                            }
                            setFilter((prev) => ({
                              ...prev,
                              bookies: Array.from(selectedSet).join(","),
                            }));
                          }}
                        />
                        <label className="-mt-1" htmlFor={element.brand}>
                          {element?.brand}
                        </label>
                      </div>
                    ))
                    : null}
                </div>
                <div className="w-full h-[100px]">
                  <Button
                    onClick={() => {
                      if (Object.keys(user || {}).length) {
                        reload_data();
                        setIsOpen(false);
                      } else if (Object.keys(user || {}).length === 0) {
                        refetch();
                        setIsOpen(false);
                      }
                    }}
                  >
                    Apply filter
                  </Button>
                </div>
              </div>
            </div>
            <div onClick={toggleMenu} className="h-full lg:grow grow-0 " />
          </div>
        </div>
      )}

      <div className="landing-row">
        <div className="row">
          <div className="col-xxl">
            <button
              onClick={toggleMenu}
              className="filter flex justify-center w-fit lg:w-[17%] items-center gap-2"
            >
              <img src={sort} className="img-fluid sort" alt="sort" />
              Filter
            </button>
            <Functions setText={setText}></Functions>

            <div className="table-bacground">
              <div className="table-responsive overflow-x-auto">
                <table className="table">
                  <thead>
                    <tr className="w-full">
                      <th scope="col" className="lg:text-[18px] text-[12px]">
                        Username
                      </th>
                      <th scope="col" className="lg:text-[18px] text-[12px]">
                        Platform
                      </th>
                      <th
                        scope="col"
                        className="lg:text-[18px] whitespace-nowrap text-[12px]"
                      >
                        Booking code
                      </th>
                      <th
                        scope="col"
                        className="lg:text-[18px] whitespace-nowrap text-[12px]"
                      >
                        Total Odds
                      </th>
                      <th scope="col"></th>
                      <th scope="col"></th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(visibleBetCodes)
                      ? visibleBetCodes
                        .filter(
                          (entry) =>
                            entry?.user?.username
                              ?.toLowerCase()
                              ?.includes(text.toLowerCase()) ||
                            entry?.bookie
                              ?.toLowerCase()
                              ?.includes(text.toLowerCase())
                        )
                        .map((elem) => {
                          return (
                            <tr key={elem?.externalId}>
                              <td className="lg:text-[14px] text-[12px]">
                                @{elem?.user?.username}
                              </td>
                              <td className="lg:text-[14px] text-[12px]">
                                {elem?.bookie}
                              </td>
                              <td
                                onClick={() => {
                                  if (Object.keys(user).length) {
                                    handleCopyCode(
                                      elem?.code || "",
                                      elem?.externalId
                                    );
                                  } else {
                                    setOpenModal(true);
                                  }
                                }}
                                className={`flex items-center lg:text-[14px] text-[12px] ${!Boolean(Object.keys(user).length) &&
                                  "blur-sm"
                                  }`}
                              >
                                {elem?.code || "V4JVL2"}
                                <img
                                  src={copy2}
                                  className="img-fluid cursor-pointer copy2 lg:w-[16px] lg:h-[16px] w-[12px] h-[12px]"
                                  alt="cop2"
                                />
                              </td>
                              <td className="lg:text-[14px] text-[12px]">
                                {elem?.odds}
                              </td>
                              <td>
                                <button
                                  onClick={() => {
                                    if (Object.keys(user).length) {
                                      handleCopyCode(
                                        elem?.code || "",
                                        elem?.externalId
                                      );
                                    } else {
                                      setOpenModal(true);
                                    }
                                  }}
                                  className="copy-btn flex items-center justify-center"
                                >
                                  <img
                                    src={copy}
                                    className="img-fluid copy lg:w-[16px] lg:h-[16px] w-[12px] h-[12px]"
                                    alt="icon"
                                  />
                                  <p className="flex items-center lg:text-[14px] text-[12px]">
                                    Copy
                                  </p>
                                </button>
                              </td>
                              <td className="flex items-center">
                                <tags className="circle-tag">
                                  {elem?._count?.likedBy}
                                </tags>
                                <img
                                  src={like}
                                  onClick={() => handleLike(elem?.externalId)}
                                  className="img-fluid like w-[16px] h-[16px]"
                                  alt="like"
                                />
                              </td>
                              <td className="capitalize min-w-[130px]">
                                <Countdown
                                  date={
                                    new Date(elem?.expiry).getTime() + 3600000
                                  }
                                  renderer={renderer}
                                />
                              </td>
                            </tr>
                          );
                        })
                      : null}
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <Pagination
                totalItems={betCodes.length}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Table;
